import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import MenuItem from "@material-ui/core/MenuItem";
import {
  IAdminRegisterModal,
  IProfileEditModal,
  ISearchBox
} from "../../customHook/NavigationBarHook";
import { colors, navigationBarHeight } from "../../design";
import Title from "../atoms/Title";
import DropDown from "../molecules/DropDown";
import SearchBox from "../molecules/SearchBox";

interface IProps {
  title: string;
  active: "users" | "talks";
  children: React.ReactNode;

  adminRegisterModalState: IAdminRegisterModal;
  profileEditModalState: IProfileEditModal;
  searchBoxState: ISearchBox;
}

const PageNavigation: React.FC<IProps> = ({
  title,
  active,
  children,

  adminRegisterModalState,
  profileEditModalState,
  searchBoxState
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <OutWrapper>
      <NavigationBar>
        <Container className="container">
          <div className="div">
            <NavigationTilte level="h2">{title}</NavigationTilte>
            <DropDown
              title="Admin Info"
              icon="fas fa-user"
              handleClick={handleClick}
              handleClose={handleClose}
              anchorEl={anchorEl}
            >
              <MenuItem onClick={handleClose}>
                <CustomAnchor href="#" onClick={adminRegisterModalState.open}>
                  Adminユーザーの追加
                </CustomAnchor>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <CustomAnchor href="#" onClick={profileEditModalState.open}>
                  プロフィールの編集
                </CustomAnchor>
              </MenuItem>
            </DropDown>
          </div>
          <IconAlign>
            <FriendsOrTalksLink
              to="/"
              className={active === "users" ? "active" : ""}
            >
              <NavigationIcon className="fas fa-user" />
              友だち
            </FriendsOrTalksLink>
            <FriendsOrTalksLink
              to="/talks"
              className={active === "talks" ? "active" : ""}
            >
              <NavigationIcon className="fas fa-comment-lines" />
              トーク
            </FriendsOrTalksLink>
          </IconAlign>
          <SearchBox
            searchText={searchBoxState.searchText}
            onChange={searchBoxState.change}
            clearSearchBox={searchBoxState.clear}
          />
        </Container>
      </NavigationBar>
      <Content>{children}</Content>
    </OutWrapper>
  );
};

export default PageNavigation;

const OutWrapper = styled.div`
  height: ${navigationBarHeight};
`;

const NavigationBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ddd;
`;

const Container = styled.div``;

const IconAlign = styled.div`
  display: flex;
  justify-content: center;
  aligs-items: center;
  height: 50px;
  z-index: 2;
`;

const NavigationIcon = styled.i`
  font-size: 25px;
`;

const FriendsOrTalksLink = styled(Link)`
  color: ${colors.lightGray};
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &.active {
    color: ${colors.darkGray};
  }
`;

const NavigationTilte = styled(Title)`
  text-align: center;
`;

const CustomAnchor = styled.a`
  color: #000;
`;

const Content = styled.div``;
